"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NcPinsComparison = exports.NcPinsRowSchema = exports.NC_PINS_ROW_KEY = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const comparison_spec_1 = require("../comparison-spec");
const pin_id_normalization_1 = require("./pin-id-normalization");
exports.NC_PINS_ROW_KEY = 'nc_pins';
exports.NcPinsRowSchema = z.object({
    key: z.string(),
    pins: z.string().array(),
    floatingBehavior: sigma_engine_shared_1.DesignModels.SignalFloatingBehaviorSchema.optional(),
});
class NcPinsComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['key'], ['pins', 'floatingBehavior']);
        this.membershipContestable = false;
    }
    toRows(data) {
        return [{ key: exports.NC_PINS_ROW_KEY, ...data }];
    }
    fromRows(rows) {
        const [row] = rows;
        if (row === undefined) {
            return { pins: [] };
        }
        const { key: _key, ...data } = row;
        return data;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'pins' && Array.isArray(value)) {
            const canonical = value
                .map((pin) => (typeof pin === 'string' ? (0, pin_id_normalization_1.normalizePinIdForComparison)(pin) : String(pin)))
                .sort();
            return JSON.stringify(canonical);
        }
        return super.normalize(column, value, row);
    }
}
exports.NcPinsComparison = NcPinsComparison;
//# sourceMappingURL=nc-pins.comparison.js.map